export default {"src":"/_next/static/media/ic_share.5c18be7a.svg","height":24,"width":20,"blurWidth":0,"blurHeight":0};